<div class="emoji-picker">
	<div class="emoji-picker_search">
		<i class="far fa-search emoji-picker_search_icon"></i>
		<input #searchRef
			   type="text"
			   class="form-control form-control-sm"
			   placeholder="Search emojis..."
			   autocomplete="off"
			   [(ngModel)]="searchText"
			   (ngModelChange)="onSearchChanged()" />
		<button *ngIf="isSearching" type="button" class="emoji-picker_search_clear" title="Clear" (click)="clearSearch()">
			<i class="far fa-times"></i>
		</button>
	</div>

	<!-- The tabs are what the grid is showing when nothing has been searched for.  While it is showing
		 results they'd be pointing at a grid that isn't theirs, so they stand down until the search is
		 cleared. -->
	<div class="emoji-picker_tabs" *ngIf="!isSearching">
		<button *ngFor="let category of categories; let i = index"
				type="button"
				class="emoji-picker_tab"
				[class.emoji-picker_tab-active]="i === activeCategoryIndex"
				[title]="category.name"
				(click)="selectCategory(i)">
			<i class="far" [ngClass]="category.icon"></i>
		</button>
	</div>

	<div class="emoji-picker_grid">
		<button *ngFor="let emoji of (isSearching ? searchResults : categories[activeCategoryIndex].emojis)"
				type="button"
				class="emoji-picker_emoji"
				(click)="selectEmoji(emoji)">{{emoji}}</button>
	</div>

	<div *ngIf="isSearching && searchResults.length === 0" class="emoji-picker_empty">No emojis found</div>
</div>
